import { render, staticRenderFns } from "./FormRadio.vue?vue&type=template&id=5b3eae60"
import script from "./FormRadio.vue?vue&type=script&setup=true&lang=js"
export * from "./FormRadio.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports